import script from "./TeacherDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherDashboard.vue?vue&type=script&setup=true&lang=js"

import "./TeacherDashboard.vue?vue&type=style&index=0&id=609dfa00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609dfa00"]])

export default __exports__